/** @format */
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import React, {
    Fragment,
    FunctionComponent,
    ReactNode,
    useContext,
} from 'react';

import { CalculationContext } from '@toucan/client/shared/context/calculation';

type BaseSummaryItemPriceProps = {
    className?: string;
    priceLabel?: string;
    price?: string | ReactNode;
};

export const BaseSummaryItemPrice: FunctionComponent<
    BaseSummaryItemPriceProps
> = ({ className = '', priceLabel, price }) => {
    const { isFetchingTotals } = useContext(CalculationContext);

    function renderPrice() {
        if (isFetchingTotals || !price) {
            return (
                <Skeleton
                    data-testid="summary-item__price-loading"
                    variant={SkeletonVariant.TEXT}
                />
            );
        }

        return (
            <p className={className} data-testid="summary-item__price">
                {price}
            </p>
        );
    }

    return (
        <Fragment>
            {priceLabel && <Fragment>{priceLabel}</Fragment>}
            {renderPrice()}
        </Fragment>
    );
};
